import React, {useState} from 'react';
import {
    IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
    useIonViewWillEnter, useIonViewWillLeave,
} from '@ionic/react';
import AdminGate from '../../components/auth/AdminGate';
import NfcChipEditor from '../../components/admin/NfcChipEditor';

const AdminNfc: React.FC = () => {
    const [active, setActive] = useState(true);
    useIonViewWillEnter(() => setActive(true));
    useIonViewWillLeave(() => setActive(false));

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start"><IonMenuButton/></IonButtons>
                    <IonTitle>NFC-chip schrijven</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <AdminGate>
                    <div className="admin-nfc-content"><NfcChipEditor disabled={!active}/></div>
                </AdminGate>
            </IonContent>
        </IonPage>
    );
};

export default AdminNfc;
